import { Injectable } from '@angular/core';

import { HTTPHelperService } from './http-helper.services';

@Injectable()
export class SuperAdminService {

    constructor(private httpHelper: HTTPHelperService) {
    }

    public getProfile({ url, params }) {
        return this.httpHelper.getFunction({ url: url, params: params });
    }

    public getAllUsers({ url, params }) {
        return this.httpHelper.getFunction({ url: url, params: params });
    }

    public addUser({ url, params }) {
        return this.httpHelper.postFunction({ url: url, params: params });
    }

    public editUser({ url, params }) {
        return this.httpHelper.putFunction({ url: url, params: params });
    }

    public deleteUser({ url, params }) {
        return this.httpHelper.putFunction({ url: url, params: params });
    }

    public updateUserPassword({ url, params }) {
        return this.httpHelper.putFunction({ url: url, params: params });
    }
    public addAppModule({ url, params }) {
        return this.httpHelper.postFunction({ url: url, params: params });
    }
    public loadAppModule({ url, params }) {
        return this.httpHelper.getFunction({ url: url, params: params });
    }
    public deleteAppModule({ url, params }) {
        return this.httpHelper.deleteFunction({ url: url, params: params });
    }

    public editAppModule({ url, params }) {
        return this.httpHelper.putFunction({ url: url, params: params });
    }
    public addAppVersion({ url, params }) {
        return this.httpHelper.postFunction({ url: url, params: params });
    }
    public loadAppVersion({ url, params }) {
        return this.httpHelper.getFunction({ url: url, params: params });
    }
    public deleteAppVersion({ url, params }) {
        return this.httpHelper.deleteFunction({ url: url, params: params });
    }

    public editAppVersion({ url, params }) {
        return this.httpHelper.putFunction({ url: url, params: params });
    }
    public addSchoolConfig({ url, params }) {
        return this.httpHelper.postFunction({ url: url, params: params });
    }
    public loadSchoolConfig({ url, params }) {
        return this.httpHelper.getFunction({ url: url, params: params });
    }
    public deleteSchoolConfig({ url, params }) {
        return this.httpHelper.deleteFunction({ url: url, params: params });
    }

    public editSchoolConfig({ url, params }) {
        return this.httpHelper.putFunction({ url: url, params: params });
    }
}
